import React from 'react';
import type { LegalDocument, NoticeVariant } from './legalTypes';

export const LegalNotice: React.FC<{
  document: LegalDocument | null; variant: NoticeVariant; error: boolean; retry: () => void;
}> = ({ document, variant, error, retry }) => {
  if (!document) return <p role="status">
    {error ? <>We couldn’t load the Terms. <button type="button" onClick={retry}>Try again</button></> : 'Loading Terms…'}
  </p>;
  return <p data-testid="legal-notice" data-legal-document={document.id} data-notice-variant={variant}
    style={{ fontSize: 14, lineHeight: 1.5, color: 'hsl(var(--foreground))', margin: '12px 0 0' }}>
    {document.notices[variant].split(/(\{terms\}|\{privacy\})/g).map((part, index) => {
      const kind = part === '{terms}' ? 'terms' : part === '{privacy}' ? 'privacy' : null;
      return kind ? <a key={index} href={`/${kind}?document=${document.id}`} target="_blank" rel="noopener noreferrer"
        style={{ color: 'inherit', textDecoration: 'underline' }}>{kind === 'terms' ? 'Terms of Use' : 'Privacy Policy'}</a> : part;
    })}
  </p>;
};
